import RootAccountsTable from './RootAccountsTable';

export default RootAccountsTable;
